import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  Modal,
  ModalContent,
  Button,
  ProgressBar,
  TextField,
  Stack,
  Space,
} from 'mw-style-react';

import { DEL_MODAL } from 'constants';
import { useIntl } from 'hooks';
import { CREATE_ACTOR } from '@control-front-end/common/constants/graphActors';
import AppUtils from '@control-front-end/utils/utils';
import mes from './intl';
// eslint-disable-next-line no-unused-vars
import sModal from '../../Modal.scss'; // NOSONAR
// eslint-disable-next-line no-unused-vars
import sLocal from './CreateFolder.scss'; // NOSONAR

function CreateFolder(props) {
  const {
    visibility,
    onClose,
    data: { callback },
    modalName,
  } = props;
  const t = useIntl();
  const dispatch = useDispatch();
  const systemForms = useSelector((state) => state.systemForms) || {};
  const stateFormId = systemForms.state?.id;
  const [isLoading, setLoading] = useState(false);
  const [folderName, setFolderName] = useState('Actor');

  const handleSubmit = () => {
    if (!stateFormId) {
      return;
    }

    setLoading(true);
    dispatch({
      type: CREATE_ACTOR.REQUEST,
      payload: {
        formId: stateFormId,
        title: folderName,
        formData: {
          polygon: JSON.stringify(AppUtils.makeDefaultPolygon()),
        },
      },
      callback: (actor) => {
        setLoading(false);
        if (callback) callback(actor);
        dispatch({ type: DEL_MODAL, payload: modalName });
      },
    });
  };

  const renderLoader = () => (
    <Stack.H fullWidth justifyContent="center">
      <ProgressBar type="circle" size="large" />
    </Stack.H>
  );

  return (
    <Modal
      id="createFolderModal"
      styleName="sModal.modal sLocal.modal"
      visibility={visibility}
      onClose={onClose}
      label={t(mes.createNewFolder)}
      size="small"
      dataTestId="modal-create-folder"
    >
      <ModalContent styleName="sModal.modal__content sLocal.content">
        <TextField
          label={t(mes.name)}
          value={folderName}
          onChange={({ value }) => setFolderName(value)}
          autoFocus
          bordered
          dataTestId="modal-create-folder-name-input"
        />
        {isLoading ? renderLoader() : null}
      </ModalContent>
      <Space>
        <Stack.H
          fullWidth
          size={Stack.SIZE.medium}
          justifyContent="spaceBetween"
        >
          <Button
            size="smallplus"
            fullWidth
            label={t(mes.create)}
            onClick={handleSubmit}
            disabled={isLoading}
            visibility={isLoading ? 'disabled' : 'visible'}
            dataTestId="modal-create-folder-submit"
          />
        </Stack.H>
      </Space>
    </Modal>
  );
}

CreateFolder.defaultProps = {
  modalName: 'CreateFolder',
};

CreateFolder.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  data: PropTypes.shape({
    callback: PropTypes.func,
  }),
  modalName: PropTypes.string,
};

export default CreateFolder;
